import createCounterInlineComponent from "../../../../../helpers/common/TextCore/components/CounterInline/fabric";
import { TEXT_DISPLAY_NAME } from "../../utils/core";

export const Component = createCounterInlineComponent(TEXT_DISPLAY_NAME);
export default Component;
